import React from "react";


export default function MomentDisplay({momentData}) {
    return <span title={`${momentData.fromNow()} - ${momentData.format('LL | h:mA')}`}>
        {momentData.format('LL | h:mA')}
    </span>
}